import * as React from 'react';
import { useParams } from 'react-router-dom';
import { LocationCheckLog } from 'cb-model';
import { Display, NavIconContainer, PageTitle, QuerySingle, Section } from 'gossamer-front-end';

/**
 * Location Check Log Display Page
 *
 * Display details for a single location check log entry (read-only)
 * Shows complete information about a specific location check
 */
export const LocationCheckLogDisplay = (): React.JSX.Element => {
  const params = useParams();

  return (
    <>
      <NavIconContainer entityId={LocationCheckLog.id} />
      <PageTitle verb="Display" entity={LocationCheckLog} keyValue={params.key} />

      <Section>
        <QuerySingle entity={LocationCheckLog} keyValue={params.key} render={Display} />
      </Section>
    </>
  );
};
